import { ExclamationCircleOutlined } from '@ant-design/icons';
import { Flex, Modal, Radio, Select, Typography } from 'antd';
import { useEffect, useState } from 'react';
import colors from '../../../../constants/ColourConstants';
import { monthOptions, yearOptions } from '../Invoices';
import { getPastMonthAndYear } from '../../../../utils/helpers/helper';
export default function UpdateInvoiceModal({
  onOk,
  open,
  setOpen,
  n,
  count,
  nullInvoicePeriodCount,
  selectedRecords,
}) {
  const { month, year } = getPastMonthAndYear();
  const { Text } = Typography;
  const [invoiceUpdateType, setInvoiceUpdateType] = useState('selected');
  const [newStatus, setNewStatus] = useState(null);
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [invoicePeriod, setInvoicePeriod] = useState({
    month: month,
    year: year,
  });
  const [isInvoicePeriodEmpty, setIsInvoicePeriodEmpty] = useState(false);
  const [recordWithoutInvoicePeriod, setRecordWithoutInvoicePeriod] =
    useState(0);
  useEffect(() => {
    setIsInvoicePeriodEmpty(false);
    setRecordWithoutInvoicePeriod(0);
    selectedRecords.forEach((record) => {
      if (record.invoicePeriod === null) {
        setIsInvoicePeriodEmpty(true);
        setRecordWithoutInvoicePeriod((prev) => prev + 1);
      }
    });
  }, [selectedRecords]);
  return (
    <>
      <Modal
        title="Update Invoice Statuses"
        open={open}
        onCancel={() => setOpen(false)}
        onClose={() => setOpen(false)}
        okButtonProps={{
          disabled: !newStatus,
        }}
        onOk={() => {
          setShowConfirmModal(true);
          setOpen(false);
        }}
      >
        <div style={{ display: 'flex', flexDirection: 'column', gap: 6 }}>
          <Text>Choose which invoices to update.</Text>
          <Text style={{ fontSize: 12 }} italic>
            Note: Only invoices that are NOT added to a payout and voided can be
            updated.
          </Text>
        </div>
        <Radio.Group
          onChange={(e) => setInvoiceUpdateType(e.target.value)}
          defaultValue={'selected'}
          value={invoiceUpdateType}
          style={{
            display: 'flex',
            flexDirection: 'column',
            margin: '8px 0',
            gap: 4,
          }}
        >
          <Radio value={'selected'}>
            Selected invoices only -{' '}
            <Text strong>{n || 0} invoices selected</Text>
          </Radio>
          <Radio value={'query'}>
            All eligible invoices - <Text strong>{count || 0} invoices </Text>
          </Radio>
        </Radio.Group>
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 8,
            margin: '12px 0',
          }}
        >
          <Text>Change status to</Text>
          <Select
            onSelect={setNewStatus}
            value={newStatus}
            placeholder="Select status"
            style={{ width: '60%' }}
          >
            <Radio value={'Under Further Review'}>Under Further Review</Radio>
            <Radio value={'Ready for Payout'}>Ready for Payout</Radio>
            <Radio value={'Voided'}>Voided</Radio>
            <Radio value={'Ready for Resend'}>Ready for Resend</Radio>
          </Select>
          {invoiceUpdateType === 'selected' && (
            <>
              {newStatus === 'Ready for Payout' && isInvoicePeriodEmpty ? (
                <>
                  {n != recordWithoutInvoicePeriod && (
                    <Typography.Text>
                      {' '}
                      You are updating<b> {n}</b> invoices.{' '}
                      <b>
                        {recordWithoutInvoicePeriod}{' '}
                        {recordWithoutInvoicePeriod == 1 ? <>does</> : <>do</>}{' '}
                        not have an invoice period.
                      </b>{' '}
                      Please select the Invoice Period for these Invoices below.
                      Invoices with an existing Invoice Period will <b>NOT</b>{' '}
                      be updated.{' '}
                    </Typography.Text>
                  )}
                  <div style={{ margin: '14px 140px 16px 0px' }}>
                    <Text>Invoice Period</Text>
                    <Flex gap={8}>
                      <Select
                        placeholder="Month"
                        style={{ flex: 1 }}
                        defaultValue={invoicePeriod.month}
                        options={monthOptions}
                        onChange={(v) =>
                          setInvoicePeriod({ ...invoicePeriod, month: v })
                        }
                      />
                      <Select
                        placeholder="Year"
                        style={{ flex: 1 }}
                        defaultValue={invoicePeriod.year}
                        options={yearOptions}
                        onChange={(v) =>
                          setInvoicePeriod({ ...invoicePeriod, year: v })
                        }
                      />
                    </Flex>
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          )}
          {invoiceUpdateType === 'query' && (
            <>
              {newStatus === 'Ready for Payout' &&
              nullInvoicePeriodCount > 0 ? (
                <>
                  <Typography.Text>
                    {' '}
                    You are updating<b> {count}</b> invoices.{' '}
                    <b>
                      {nullInvoicePeriodCount}{' '}
                      {nullInvoicePeriodCount == 1 ? <>does</> : <>do</>} not
                      have an invoice period.
                    </b>{' '}
                    Please select the Invoice Period for{' '}
                    {nullInvoicePeriodCount == 1 ? (
                      <>this invoice </>
                    ) : (
                      <>these invoices </>
                    )}
                    below. Invoices with an existing Invoice Period will{' '}
                    <b>NOT</b> be updated.{' '}
                  </Typography.Text>
                  <div style={{ margin: '14px 140px 16px 0px' }}>
                    <Text>Invoice Period</Text>
                    <Flex gap={8}>
                      <Select
                        placeholder="Month"
                        style={{ flex: 1 }}
                        defaultValue={invoicePeriod.month}
                        options={monthOptions}
                        onChange={(v) =>
                          setInvoicePeriod({ ...invoicePeriod, month: v })
                        }
                      />
                      <Select
                        placeholder="Year"
                        style={{ flex: 1 }}
                        defaultValue={invoicePeriod.year}
                        options={yearOptions}
                        onChange={(v) =>
                          setInvoicePeriod({ ...invoicePeriod, year: v })
                        }
                      />
                    </Flex>
                  </div>
                </>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      </Modal>

      <Modal
        width={'25%'}
        open={showConfirmModal}
        title={
          <>
            <ExclamationCircleOutlined style={{ color: colors.colorWarning }} />
            <Text style={{ marginLeft: 8 }}>Confirm Invoice Status Update</Text>
          </>
        }
        onCancel={() => {
          setShowConfirmModal(false);
          setOpen(true);
        }}
        onOk={() => {
          onOk(invoiceUpdateType, null, newStatus, invoicePeriod);
          setShowConfirmModal(false);
        }}
      >
        <div
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 10,
          }}
        >
          <Text>
            You&apos;re about to update{' '}
            <Text strong>
              {invoiceUpdateType == 'selected' ? n : count} invoice statuses
            </Text>{' '}
            to <Text strong>{newStatus}</Text>.
          </Text>
          <Text>Do you want to proceed?</Text>
        </div>
      </Modal>
    </>
  );
}
